import { render, staticRenderFns } from "./Player3.vue?vue&type=template&id=4610ed06&scoped=true&"
import script from "./Player3.vue?vue&type=script&lang=js&"
export * from "./Player3.vue?vue&type=script&lang=js&"
import style0 from "./Player3.vue?vue&type=style&index=0&id=4610ed06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610ed06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSlider})
